const MuiMenuItem = {
  styleOverrides: {
    root: {
      '&.Mui-selected': {
        '&:active': {
          backgroundColor: 'rgba(0, 0, 0, 0.08)',
        },
        '&:focus': {
          backgroundColor: 'rgba(0, 0, 0, 0.08)',
        },
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.08)',
        },
        backgroundColor: 'rgba(0, 0, 0, 0.08)',
      },
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
    },
  },
  variants: [
    {
      props: { variant: 'button-contained' },
      style: {
        ':hover': {
          backgroundColor: 'secondary.dark',
        },
        backgroundColor: 'secondary.main',
        color: 'surface.white',
        display: 'flex',
        height: 48,
        justifyContent: 'center',
        margin: 0,
        width: '100%',
      },
    },
    {
      props: { variant: 'button-outlined' },
      style: {
        ':hover': {
          color: 'secondary.main',
        },
        backgroundColor: 'surface.white',
        color: 'secondary.main',
        display: 'flex',
        height: 48,
        justifyContent: 'center',
        margin: 0,
        width: '100%',
      },
    },
    {
      props: { variant: 'no hover' },
      style: {
        ':hover': {
          backgroundColor: 'transparent',
          cursor: 'default',
        },
      },
    },
    {
      props: { variant: 'nav item' },
      style: {
        ':hover': {
          backgroundColor: 'secondary.light',
        },
      },
    },
  ],
};

export default MuiMenuItem;
